import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Gallery from "./components/Gallery";
import FAQ from "./components/FAQ";
import QuoteForm from "./components/QuoteForm";
import Footer from "./components/Footer";
import WhatsAppFab from "./components/WhatsAppFab";
import LavoraConNoi from "./pages/LavoraConNoi";

const Landing = () => (
  <div className="App grain relative">
    <Navbar />
    <main>
      <Hero />
      <About />
      <Services />
      <Features />
      <HowItWorks />
      <Gallery />
      <FAQ />
      <QuoteForm />
    </main>
    <Footer />
    <WhatsAppFab />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
